import { useSyncExternalStore } from 'react';
import { isLocalDevelopment } from './environmentUtils';

const STORAGE_KEY = 'dev-role-override';
const DEV_ROLE_CHANGED_EVENT = 'dev-role-changed';

export type DevRole = 'Approver' | 'ReadOnly' | 'Administrator' | 'NoAccess';

export const DEV_ROLES: DevRole[] = ['Approver', 'ReadOnly', 'Administrator', 'NoAccess'];

export function getDevRoleOverride(): string | null {
  if (!isLocalDevelopment()) {
    return null;
  }

  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setDevRoleOverride(role: DevRole | null): void {
  try {
    if (role === null) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, role);
    }
  } catch {
    // localStorage unavailable
  }
  window.dispatchEvent(new Event(DEV_ROLE_CHANGED_EVENT));
}

function subscribe(callback: () => void): () => void {
  window.addEventListener(DEV_ROLE_CHANGED_EVENT, callback);
  return () => window.removeEventListener(DEV_ROLE_CHANGED_EVENT, callback);
}

export function useDevRole(): DevRole | null {
  return useSyncExternalStore(subscribe, getDevRoleOverride) as DevRole | null;
}
